import { ITab } from 'xangle-ui/dist_types/components/tab/tab.type'

import { ValueOf } from '~/types/value-of'

export const chartPeriodType = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
} as const
export type chartPeriodType = ValueOf<typeof chartPeriodType>
export const chartPeriodLabel = {
  Daily: 'Daily',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
} as const
export type chartPeriodLabel = ValueOf<typeof chartPeriodLabel>


export const tokenChartPeriodType = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
  HALF: 'HALF',
  YTD: 'YTD',
  ALL: 'ALL',
  SELECTOR: 'SELECTOR'
} as const
export type tokenChartPeriodType = ValueOf<typeof tokenChartPeriodType>

export const COMPARE_PERIOD_LIST: ITab<tokenChartPeriodType>[] = [
  {
    label: '7D',
    value: tokenChartPeriodType.WEEK
  },
  {
    label: '1M',
    value: tokenChartPeriodType.MONTH
  },
  {
    label: '6M',
    value: tokenChartPeriodType.HALF
  },
  {
    label: '1Y',
    value: tokenChartPeriodType.YEAR
  },
  {
    leftIcon: 'calendar',
    value: tokenChartPeriodType.SELECTOR
  },
]

export const chartScaleType = {
  LOG: 'LOG',
  LINEAR: 'LINEAR',
} as const
export type chartScaleType = ValueOf<typeof chartScaleType>

export enum yAxisLeftScaleType {
  LINEAR = 'linear',
  LOGARITHMIC = 'logarithmic',
}